// Ventana de reservas (espejo de src/lib/ventanaReservas.js del servidor).
// La propiedad recibe reservas web con llegada hasta el último día del mes actual + N meses.
const hoyBogota = () => new Date().toLocaleDateString('en-CA', { timeZone: 'America/Bogota' });

export const limiteVentana = (meses, hoy = hoyBogota()) => {
  const n = parseInt(meses);
  if (!n || n < 1) return null;
  const [anio, mes] = hoy.split('-').map(Number);
  return new Date(Date.UTC(anio, mes + n, 0)).toISOString().split('T')[0];
};

export const textoLimiteVentana = (limite) => limite
  ? new Date(limite + 'T12:00:00Z').toLocaleDateString('es-CO', { day: 'numeric', month: 'long', year: 'numeric', timeZone: 'UTC' })
  : '';

export const textoMesLimite = (limite) => limite
  ? new Date(limite + 'T12:00:00Z').toLocaleDateString('es-CO', { month: 'long', year: 'numeric', timeZone: 'UTC' })
  : '';
